import React from "react";
import "./Screen1.css";

const APPLE_LOGO =
  "https://api.builder.io/api/v1/image/assets/TEMP/c107dd87a4d7ba848c6b211f8d73d01da21080b6?width=28";
const GOOGLE_PLAY_LOGO =
  "https://api.builder.io/api/v1/image/assets/TEMP/b6388aa8e2b82b2c1d02ab88b449c06222565a1e?width=28";
const MACOS_LOGO =
  "https://api.builder.io/api/v1/image/assets/TEMP/192c0415d176b7872748f3bbcbec5c3e1e3ce6f0?width=28";
const ANDROID_LOGO =
  "https://api.builder.io/api/v1/image/assets/TEMP/c3bf4e175d5288a37525aa882be7ac127b716cc2?width=28";
const SPEECH_BUBBLE_ICON =
  "https://api.builder.io/api/v1/image/assets/TEMP/1cf6c486cb7fcaaac8cc23f7dbedfa4126364c9e?width=104";
const WHATSAPP_ICON =
  "https://api.builder.io/api/v1/image/assets/TEMP/5335996a326a0ea274bc5fe8d7a906554f01227a?width=120";
const CHAT_ICON =
  "https://api.builder.io/api/v1/image/assets/TEMP/aec5deddc6160c89bf439454e79dce8e35e8ca8b?width=128";
const BOOKMARK_ICON =
  "https://api.builder.io/api/v1/image/assets/TEMP/4b05cf364d0392a4713e6022cd28d09b3d9da561?width=94";
const LOVE_ICON =
  "https://api.builder.io/api/v1/image/assets/TEMP/7f392a8c7f78cad02ccea8447db82a161a1543f9?width=128";
const PROFILE_WOMAN =
  "https://api.builder.io/api/v1/image/assets/TEMP/faf24f7354501f1ea93d005858dcb50df5d10ba4?width=192";
const PROFILE_MAN =
  "https://api.builder.io/api/v1/image/assets/TEMP/c50bba2c792441403e11c20c2ee6ab0992df9f7f?width=192";
const GLOBE_GIF =
  "https://api.builder.io/api/v1/image/assets/TEMP/1c47d10dd45d452af681f5b89ab5384d124e60ed?width=902";
const VENNCHAT_LOGO =
  "https://api.builder.io/api/v1/image/assets/TEMP/13d8c53a673f1757e474227d4613487572b2c3a9?width=120";
const SMALL_LABEL =
  "https://api.builder.io/api/v1/image/assets/TEMP/8248a32b7cd6da27437f447e21cc19b21e507cae?width=290";

/* Windows SVG icon (inline, since it's not in available Figma URLs) */
const WindowsIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="store-icon-windows"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 3.449L9.75 2.1v9.451H0V3.449zm10.949-1.536L24 0v11.4H10.949V1.913zM0 12.6h9.75v9.451L0 20.699V12.6zm10.949.05H24V24l-13.051-1.86V12.65z" fill="#00ADEF"/>
  </svg>
);

/* Person SVG icon for the yellow blob */
const PersonIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="screen1-person-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
  </svg>
);

/* ── Globe center in the 1920×1419 coordinate space ── */
const GCX = 924; // globe center x (px)
const GCY = 674; // globe center y (px)

/* Icon centers in 1920×1419 px coordinates */
const LINE_TARGETS = [
  { x: 490, y: 405 },   // purple blob (speech)
  { x: 1338, y: 357 },  // teal blob (grid)
  { x: 917, y: 380 },   // pink blob (WhatsApp)
  { x: 1487, y: 637 },  // orange blob (chat)
  { x: 849, y: 919 },   // bookmark blob
  { x: 524, y: 939 },   // yellow blob (person)
  { x: 425, y: 636 },   // profile woman
  { x: 1450, y: 898 },  // profile man
];

export default function Screen1() {
  return (
    <div className="screen1">
      <div className="screen1-canvas">

        {/* ── Logo ── */}
        <img
          src={VENNCHAT_LOGO}
          alt="VennChat"
          className="screen1-logo-icon"
        />
        <span className="screen1-logo-text">VennChat</span>

        {/* ── Download store buttons ── */}
        <div className="screen1-store-buttons">
          <div className="screen1-store-btn">
            <img src={APPLE_LOGO} alt="Apple" className="screen1-store-btn-icon" />
            <span className="screen1-store-btn-label">App store</span>
          </div>
          <div className="screen1-store-btn">
            <img src={APPLE_LOGO} alt="Apple" className="screen1-store-btn-icon" />
            <span className="screen1-store-btn-label">iSO (中国)</span>
          </div>
          <div className="screen1-store-btn">
            <img src={GOOGLE_PLAY_LOGO} alt="Google Play" className="screen1-store-btn-icon" />
            <span className="screen1-store-btn-label">Google Play</span>
          </div>
          <div className="screen1-store-btn">
            <img src={MACOS_LOGO} alt="MacOs" className="screen1-store-btn-icon" />
            <span className="screen1-store-btn-label">MacOs</span>
          </div>
          <div className="screen1-store-btn">
            <WindowsIcon />
            <span className="screen1-store-btn-label">Windows</span>
          </div>
          <div className="screen1-store-btn">
            <img src={ANDROID_LOGO} alt="Android 中国" className="screen1-store-btn-icon" />
            <span className="screen1-store-btn-label">Android (中国)</span>
          </div>
        </div>

        {/* ── Connection lines (SVG overlay) ── */}
        <svg
          className="screen1-lines-svg"
          viewBox="0 0 1920 1419"
          xmlns="http://www.w3.org/2000/svg"
        >
          {LINE_TARGETS.map((target, i) => (
            <line
              key={i}
              x1={GCX}
              y1={GCY}
              x2={target.x}
              y2={target.y}
              stroke="#DDDDDD"
              strokeWidth="1.5"
            />
          ))}
        </svg>

        {/* ── Globe ── */}
        <img src={GLOBE_GIF} alt="Globe" className="screen1-globe" />

        {/* ── Purple blob + speech bubble icon ── */}
        <svg
          className="screen1-blob-speech"
          viewBox="0 0 94 96"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M94 47C94 73.2335 85.4574 96 59.5 96C33.5426 96 0 73.2335 0 47C0 20.7665 18.5426 0 44.5 0C70.4574 0 94 20.7665 94 47Z"
            fill="#CFBBFB"
          />
        </svg>
        <img
          src={SPEECH_BUBBLE_ICON}
          alt="Speech bubble"
          className="screen1-blob-speech-icon"
        />

        {/* ── Teal blob + grid icon ── */}
        <svg
          className="screen1-blob-teal"
          viewBox="0 0 139 130"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M138.986 49.6336C138.986 85.5023 138.986 116.164 71.7491 128.836C20.3063 138.532 0 85.5023 0 49.6336C15.3426 0 36.3599 0 71.7491 0C107.138 0 120.484 0 138.986 49.6336Z"
            fill="#D3EDF0"
          />
        </svg>
        <div className="screen1-grid-icon">
          <div className="screen1-grid-icon-inner">
            <div className="grid-cell grid-cell-tl" />
            <div className="grid-cell grid-cell-bl" />
            <div className="grid-cell grid-cell-tr" />
            <div className="grid-cell grid-cell-br" />
          </div>
        </div>

        {/* ── Pink blob + WhatsApp icon ── */}
        <svg
          className="screen1-blob-whatsapp"
          viewBox="0 0 136 127"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M136 61.5C136 95.4655 105.5 138.5 67 123C19 103.675 0 95.4655 0 61.5C0 6.8854 28.8924 0 67 0C105.108 0 136 14.5 136 61.5Z"
            fill="#EAD4D7"
          />
        </svg>
        <img
          src={WHATSAPP_ICON}
          alt="WhatsApp"
          className="screen1-blob-whatsapp-icon"
        />

        {/* ── Orange blob + chat icon ── */}
        <svg
          className="screen1-blob-chat"
          viewBox="0 0 115 107"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M115 61.0234C115 92.6482 78.4375 107 45.3872 107C12.3368 107 0 77.1834 0 45.5586C0 13.9338 24.2593 0 57.3097 0C90.36 0 115 29.3987 115 61.0234Z"
            fill="#EE8263"
            fillOpacity="0.3"
          />
        </svg>
        <img
          src={CHAT_ICON}
          alt="Chat"
          className="screen1-blob-chat-icon"
        />

        {/* ── Yellow blob + person icon ── */}
        <svg
          className="screen1-blob-person"
          viewBox="0 0 101 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M101 49.968C101 77.5645 92.8298 99.9359 50.5 99.9359C15 99.9359 0 77.5645 0 49.968C13.5398 -9.3436 38.0579 3.37955 50.5 0C81.5 8.22003 90.3876 10.5624 101 49.968Z"
            fill="#FBDE98"
          />
        </svg>
        <PersonIcon />

        {/* ── Pink bookmark blob ── */}
        <svg
          className="screen1-blob-bookmark"
          viewBox="0 0 101 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M101 49.968C101 77.5645 92.8298 99.9359 50.5 99.9359C15 99.9359 0 77.5645 0 49.968C13.5398 -9.3436 38.0579 3.37955 50.5 0C81.5 8.22003 90.3876 10.5624 101 49.968Z"
            fill="#EE3368"
            fillOpacity="0.2"
          />
        </svg>
        <img
          src={BOOKMARK_ICON}
          alt="Bookmark"
          className="screen1-blob-bookmark-icon"
        />

        {/* ── Profile photos ── */}
        <img
          src={PROFILE_WOMAN}
          alt="User"
          className="screen1-profile-photo screen1-profile-woman"
        />
        <img
          src={PROFILE_MAN}
          alt="User"
          className="screen1-profile-photo screen1-profile-man"
        />

        {/* ── Love / heart icon ── */}
        <img
          src={LOVE_ICON}
          alt=""
          className="screen1-love-icon"
        />

        {/* ── Small label under globe ── */}
        <img
          src={SMALL_LABEL}
          alt=""
          className="screen1-label-img"
        />

        {/* ── Text section ── */}
        <h1 className="screen1-title">All-in-one platform</h1>
        <p className="screen1-subtitle">
          Effortless Chat,
          <br />
          Seamless Connection,
          <br />
          Unlimited Discovery.
        </p>
      </div>
    </div>
  );
}
